import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ScrollService {
    isScroll=new BehaviorSubject<boolean>(false);

  constructor() { }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/scroll.service.ts